import RecordmImporterStatsSearchM from '../model/recordm.importer.model.stats.simplesearch.js'
import RecordmImporterStatsV from '../view/recordm.importer.view.stats.js'

const RecordmImporterStatsP = function(core) {
    const statsSearchM = new RecordmImporterStatsSearchM(core);
    let startMillis;
    let currentImportId;
    let numStatLoads = 0;
    let running = false;
    let currentAbortUri;

    const _onStatsLoaded = function(_e, data) {
        if(running){
            if(currentAbortUri) {
                statsV.enableAbort();
            }
            const stats = data.stats;
            const summaryStatM = stats.getSummaryForImportId(currentImportId);

            numStatLoads++;

            if(summaryStatM){
                statsV.removeStatsLoadingError();
                statsV.updateProgress(summaryStatM.getNumSuccesses(),
                    summaryStatM.getNumErrors(),
                    summaryStatM.getNumDiscarded());

                const importErrors = stats.getLineStatsForImportId(currentImportId)
                    .filter((stat) => stat.isDiscarded() || stat.hasError())
                    .map((stat) => ({
                        rowNum: stat.getRowNum(),
                        result: stat.getResult(),
                        msg: stat.getMessage()
                    }));

                statsV.showErrors(importErrors);
            }

            if (summaryStatM && summaryStatM.isDone()) {
                running = false;

                if (!statsV.timerRunning()) {
                    statsV.updateTimer(new Date().getTime() - startMillis);
                }

                statsV.stopTimer();

                statsV.showImportFinished();

            } else if (!statsV.timerRunning()) {
                statsV.updateTimer(new Date().getTime() - startMillis);
                statsV.startTimer();
            }
        }
    };

    const _onStatsLoadFinished = function(_e, data) {
        if(data.status && data.statusText){
            statsV.showStatsLoadingError(data.status, data.statusText);
            window.console.log("There was an error loading the import statistics", data);
        }
    };

    const statsV = new RecordmImporterStatsV(core, {
        getLoadStatsJobFrequency: function(){
            // Begin loading the stats in intervals of 2 seconds for 10 seconds (5 loads)
            // Change the load frequency for intervals of 5 seconds for 20 seconds (4 loads)
            // Finally, load the stats in intervals of 10 seconds until the file is completly processed

            if(numStatLoads < 5){
                return 2;
            } else if(numStatLoads >= 5 && numStatLoads < 9){
                return 5;
            }

            return 10;
        },
        loadImportStats: function() {
            if(running) statsSearchM.getStatsFor(currentImportId);
        },
        abort: function(){
            if(running) {
                statsSearchM.abort(currentAbortUri, currentImportId);

                running = false;
                statsV.stopTimer();

                setTimeout(() => {
                    statsSearchM.getStatsFor(currentImportId);
                    statsV.showImportFinished();
                }, 5000)
            }
        }
    });

    return{
        start: function($container, fileName, importId, abortUri) {
            currentImportId = importId;
            startMillis = new Date().getTime();
            running = true;
            currentAbortUri = abortUri;

            statsV.start($container, fileName);

            core.subscribe("recordm:search:rm-importer-stats:success", _onStatsLoaded);
            core.subscribe("recordm:search:finished", _onStatsLoadFinished);
        },
        stop: function() {
            running = false;
            currentImportId = undefined;
            startMillis = undefined;
            numStatLoads = 0;

            statsV.stop();

            statsSearchM.reset();

            core.unsubscribe("recordm:search:rm-importer-stats:success", _onStatsLoaded);
            core.unsubscribe("recordm:search:finished", _onStatsLoadFinished);
        }
    };
};

export default RecordmImporterStatsP;

